<div class="navbar-area">
    <div class="mobile-nav">
        <a routerLink="/" class="logo"><img src="assets/img/mylogo/Orange/logo2.png" alt="Logo"></a>
    </div>
    
    <div class="main-nav">
        <div class="container-fluid">
            <nav class="container-max-2 navbar navbar-expand-md navbar-light ">
                <a class="logo" routerLink="/"><img src="assets/img/mylogo/Orange/logo2.png" alt="Logo"></a>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav m-auto">

                        <li class="nav-item" style="padding:15px 20px;"><a routerLink="/" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Home</a></li>

                        <li class="nav-item" style="padding:15px 20px;">
                            <a href="javascript:void(0);" class="nav-link">Services <i class='bx bx-plus'></i></a>

                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="/extended-team" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Extended Team</a></li>

                                <li class="nav-item"><a routerLink="/discovery" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Discovery</a></li>

                                <li class="nav-item"><a routerLink="/technology-consulting" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Technology Consulting</a></li>

                                <li class="nav-item"><a routerLink="/software-development" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Software Development</a></li>
                            </ul>
                        </li>

                        <li class="nav-item" style="padding:15px 20px;">
                            <a href="javascript:void(0);" class="nav-link">Expertise <i class='bx bx-plus'></i></a>

                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a routerLink="/data-analytics" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Data Analytics <i class='bx bx-plus'></i></a>

                                    <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/data-warehouse-consulting" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Data Warehouse Consulting </a></li>

                                        <li class="nav-item">
                                            <a routerLink="/business-intelligence" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Business Intelligence <i class='bx bx-plus'></i></a>

                                            <ul class="dropdown-menu">
                                                <li class="nav-item"><a routerLink="/power-bi" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Power BI</a></li>
        
                                                <li class="nav-item"><a routerLink="/tableau" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Tableau</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/cloud-solutions" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Cloud Solutions <i class='bx bx-plus'></i></a>

                                    <ul class="dropdown-menu">
                                        <!-- <li class="nav-item"><a routerLink="/case-study" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Cloud Native Services</a></li>

                                        <li class="nav-item"><a routerLink="/case-study-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Cloud Migration</a></li>

                                        <li class="nav-item"><a routerLink="/case-study-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">DevOps</a></li> -->

                                        <li class="nav-item"><a routerLink="/aws-consulting" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Amazon Web Services</a></li>

                                        <li class="nav-item"><a routerLink="/informatica-cloud-services" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Informatica Cloud Services</a></li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/database-services" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Database Services <i class='bx bx-plus'></i></a>
                                
                                    <ul class="dropdown-menu">

                                        <li class="nav-item"><a routerLink="/oracle-managed-service" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Oracle Managed Service</a></li>

                                        <li class="nav-item"><a routerLink="/sql-server-managed-service" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">SQL Server Managed Service</a></li>
                                        
                                        <li class="nav-item"><a routerLink="/remote-database-support" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Remote Database Support</a></li>

                                        <li class="nav-item"><a routerLink="/database-monitoring-and-health-check" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Database Monitoring & Health Check</a></li>

                                        <li class="nav-item"><a routerLink="/database-patching-and-upgrades" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Database Patching & Upgrade</a></li>

                                        <li class="nav-item"><a routerLink="/database-high-availability-and-disaster-recovery" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Database High Availability & DR</a></li>

                                        <li class="nav-item"><a routerLink="/database-performance-tuning" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Database Performance Tuning</a></li>
                                    </ul>
                                </li>

                                <!-- <li class="nav-item"><a routerLink="/product-discovery" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Discovery</a></li> -->
                            </ul>
                        </li>

                        <li class="nav-item" style="padding:15px 20px;"><a routerLink="/about" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">About Us</a></li>
                    </ul>

                    <div class="side-nav d-in-line align-items-center">
                        <!-- <div class="side-item">
                            <div class="search-box">
                                <i class="flaticon-loupe"></i>
                            </div>
                        </div>
                        <div class="side-item">
                            <div class="user-btn">
                                <a routerLink="/"><i class="flaticon-contact"></i></a>
                            </div>
                        </div> -->
                        <div class="side-item">
                            <div class="nav-add-btn">
                                <a routerLink="/contact" class="nav-menu-btn">Contact Us <i class='bx bx-plus'></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>

    <div class="side-nav-responsive">
        <div class="container">
            <div class="dot-menu">
                <div class="circle-inner">
                    <div class="circle circle-one"></div>
                    <div class="circle circle-two"></div>
                    <div class="circle circle-three"></div>
                </div>
            </div>
            
            <div class="container">
                <div class="side-nav-inner">
                    <div class="side-nav justify-content-center  align-items-center">
                        <div class="side-item">
                            <div class="search-box">
                                <i class="flaticon-loupe"></i>
                            </div>
                        </div>
                        <div class="side-item">
                            <div class="user-btn">
                                <a routerLink="/"><i class="flaticon-contact"></i></a>
                            </div>
                        </div>
                        <div class="side-item">
                            <div class="nav-add-btn">
                                <a routerLink="/contact" class="nav-menu-btn">Contact Us <i class='bx bx-plus'></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="search-overlay">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-layer"></div>
            <div class="search-layer"></div>
            <div class="search-layer"></div>
            
            <div class="search-close">
                <span class="search-close-line"></span>
                <span class="search-close-line"></span>
            </div>

            <div class="search-form">
                <form>
                    <input type="text" class="input-search" placeholder="Search here...">
                    <button type="submit"><i class="flaticon-loupe"></i></button>
                </form>
            </div>
        </div>
    </div>
</div>